import { Options, Vue } from "vue-class-component";
import { PaymentDto } from "@/shared/api-contract/api-contract";
import ManualTransferPopup from "@/dashboard/my-orders/new-popup/manual-transfer-popup/manual-transfer-popup.vue";

@Options({
    components: {
        ManualTransferPopup,
    },
})
export class ManualTransferConfirmPopup extends Vue {
    closePopup() {
        this.$emit("close");
    }

    confirm() {
        this.$emit("confirm");
    }

    goBack() {
        this.$emit("back");
    }
}
